import React from 'react';
import { TrainingState, useTrainingStore } from '~/training/state';
import { SettingsPages, useSettingsStore } from '../Store';
import { LocalePage } from './LocalePage';

const selector = (s: TrainingState) => ({
  locale: s.mediumLocale,
  availableLocales: s.mediumLocales,
  setLocale: s.setMediumLocale
});

export const MediumLocalePage = () => {
  const props = useTrainingStore(selector);
  const { page } = useSettingsStore();
  if (page !== SettingsPages.MediumLocale) return null;

  return <LocalePage {...props} />;
};
